import {
  BatteryMid,
  Calendar,
  Hand,
  HeartHand,
  Lightbulb02,
  Lightning02,
  MessageChatCircle,
  Rocket02,
  Scales02,
  Shield01,
  Sliders04,
  Target05,
  Trophy01,
  Users01,
  Zap,
} from "@untitled-ui/icons-react";
import { ComponentType, SVGProps } from "react";

export type Status = "good" | "warn" | "alert" | "critical";
export type Priority = "positive" | "low" | "medium" | "high";

export const statusDot: Record<Status, string> = {
  good: "bg-emerald-500",
  warn: "bg-amber-400",
  alert: "bg-orange-500",
  critical: "bg-red-500",
};

export const statusBadge: Record<Status, string> = {
  good: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  warn: "bg-amber-50 text-amber-700 ring-amber-600/20",
  alert: "bg-orange-50 text-orange-700 ring-orange-600/20",
  critical: "bg-red-50 text-red-700 ring-red-600/20",
};

export const priorityBadge: Record<
  Priority,
  { status: Status; label: string }
> = {
  high: { status: "critical", label: "Needs Attention" },
  medium: { status: "alert", label: "Monitor" },
  low: { status: "warn", label: "Low Priority" },
  positive: { status: "good", label: "Doing Well" },
};

export const sourceTypeLabel: Record<string, string> = {
  meeting: "Meeting",
  goal: "Goal",
  recognition: "Recognition",
  checkin: "Check-in",
  work_summary: "Work Summary",
};

export const sourceTypeDot: Record<string, string> = {
  meeting: "bg-blue-400",
  goal: "bg-emerald-400",
  recognition: "bg-amber-400",
  checkin: "bg-purple-400",
  work_summary: "bg-gray-400",
};

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

// TODO(jordanyu): We should make dimension name/key more strongly typed
// so that we can guarantee the dimensions names are always matched with an icon
// Put them with TopicflowIconMap instead of separate map
export const dimensionIcons: Record<string, IconComponent> = {
  "Career Growth": Rocket02,
  "Blockers & Support": Lightning02,
  "Blockers Support": Lightning02,
  "Workload Balance": Scales02,
  "Psychological Safety": Shield01,
  "Feedback & Recognition": Trophy01,
  "Feedback Recognition": Trophy01,
  "Decision Making": Zap,
  "Autonomy & Delegation": Hand,
  "Autonomy Delegation": Hand,
  "Energy Alignment": BatteryMid,
  "Frequency Health": Calendar,
  "Meeting Structure": Sliders04,
  "Talk Ratio": MessageChatCircle,
  "Personal Connection": HeartHand,
  "Expectations Tracker": Target05,
  "Team Dynamics": Users01,
};

// TODO(jordanyu): We should make tag icons strongly typed/synced with the backend
// so that we can guarantee all tags have an associated icon/
// These tags currently generated from AgendaItem.tags field which is free-form text from the LLM
// Put them with TopicflowIconMap instead of separate map
export const tagIcons: Record<string, IconComponent> = {
  career: Rocket02,
  "career-growth": Rocket02,
  growth: Rocket02,
  mentoring: Rocket02,
  blocker: Lightning02,
  blockers: Lightning02,
  workload: Scales02,
  burnout: Scales02,
  sustainability: Scales02,
  "psychological-safety": Shield01,
  "retention-risk": Shield01,
  feedback: Trophy01,
  recognition: Trophy01,
  visibility: Trophy01,
  decision: Zap,
  "decision-making": Zap,
  "follow-through": Zap,
  autonomy: Hand,
  "energy-alignment": BatteryMid,
  frequency: Calendar,
  "meeting-structure": Sliders04,
  process: Sliders04,
  planning: Sliders04,
  personal: HeartHand,
  "personal-connection": HeartHand,
  rapport: HeartHand,
  relationship: HeartHand,
  "well-being": HeartHand,
  goals: Target05,
  expectations: Target05,
  team: Users01,
  "team-dynamics": Users01,
  project: Lightbulb02,
};

export const defaultIcon: IconComponent = Lightbulb02;
